export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-07.d0f81beb.jpg";